
import { useToast } from "@/components/ui/use-toast";

export const useCopyReferralLink = () => {
  const { toast } = useToast();

  const copyReferralLink = async (referralLink: string) => {
    try {
      await navigator.clipboard.writeText(referralLink);
      toast({
        title: "Copied!",
        description: "Referral link copied to clipboard",
      });
      return true;
    } catch (error) {
      console.error("Failed to copy:", error);
      toast({
        title: "Error",
        description: "Failed to copy link",
        variant: "destructive"
      });
      return false;
    }
  };

  return { copyReferralLink };
};
